import api from './api';
import { fetchPage } from './pagedParams';

const deliveryService = {
  // Server-side paged list of the 58 wilayas (Spring Page) for the URL-driven DataTable.
  getDeliveryPage: (params) => fetchPage('/admin/delivery', params),

  getDeliveryById: async (id) => (await api.get(`/admin/delivery/${id}`)).data,

  // PATCH the home price + the per-company prices of one wilaya:
  // { homeDeliveryPrice, companyPrices: [{ companyId, price }] }
  updatePrices: async (id, prices) => (await api.patch(`/admin/delivery/${id}/prices`, prices)).data,

  // Delivery companies (Zr, Yalidine, ...). Never deleted, only deactivated.
  getCompanies: async () => (await api.get('/admin/delivery-companies')).data,
  createCompany: async (payload) => (await api.post('/admin/delivery-companies', payload)).data,
  updateCompany: async (id, payload) => (await api.put(`/admin/delivery-companies/${id}`, payload)).data,
  setCompanyActive: async (id, active) =>
    (await api.patch(`/admin/delivery-companies/${id}/active`, null, { params: { active } })).data,
};

export default deliveryService;
